export default __webpack_public_path__ + "static/team-hp-fe1a6b59ecf55e7cf8763b0b53731e01.png";